<template>
  <div id="app">
    <global-nav></global-nav>
    <router-view/>
    <app-footer></app-footer>
  </div>
</template>

<script>
import GlobalNav from '@/components/GlobalNav'
import AppFooter from '@/components/AppFooter'

export default {
  name: 'App',
  components: {
    GlobalNav,
    AppFooter
  },
}
</script>

<style>
@media all and (max-width: 767px) {
}
@media all and (min-width: 768px) {
}
</style>



// WEBPACK FOOTER //
// src/App.vue